export const topicLectureTableData = {
  columns: [
    {
      label: "讲座类型",
      prop: "lectureTypeName",
      minWidth: "120",
      // showOverflowTooltip: true
    },
    {
      label: "讲座主题",
      prop: "lectureName",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "授课老师",
      prop: "teacher",
      width: "90",
    },
    {
      label: "授课老师职务",
      prop: "teacherUnitPosition",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "讲座时间",
      prop: "lectureDateStr",
      width: "180",
      showOverflowTooltip: true,
    },
    {
      label: "学时",
      prop: "lectureHours",
      width: "80",
    },
    {
      label: "主办单位",
      prop: "organizer",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "讲座地点",
      prop: "lecturePlace",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "参训时所在单位及职务",
      prop: "trainedUnitPosition",
      minWidth: "100",
      showOverflowTooltip: true,
    },
  ],
  operateConfig: [
    {
      icon: "icon-delete",
      name: "删除",
      permission: "topicLecture:delete",
    },
  ],
};

export const theoreticalStudyTableData = {
  columns: [
    {
      label: "学习名称",
      prop: "lectureName",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "学习时间",
      prop: "lectureDateStr",
      minWidth: "140",
      sortable: true,
    },
    {
      label: "学时",
      prop: "lectureHours",
      minWidth: "80",
    },
    {
      label: "学习单位",
      prop: "organizer",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "学习地点",
      prop: "lecturePlace",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "参训时所在单位及职务",
      prop: "trainedUnitPosition",
      minWidth: "150",
      showOverflowTooltip: true,
    },
  ],
  operateConfig: [
    {
      icon: "icon-delete",
      name: "删除",
      permission: "topicLectureLearn:delete",
    },
  ],
};


export const otherTrainTableData = {
  columns: [
     {
      label: "培训名称",
      prop: "lectureName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "培训时间",
      prop: "lectureDateStr",
      minWidth: "240",
      showOverflowTooltip: true
    },
    {
      label: "学时",
      prop: "lectureHours",
      minWidth: "80",
    },
    {
      label: "培训单位",
      prop: "organizer",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "培训地点",
      prop: "lecturePlace",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "参训时所在单位及职务",
      prop: "trainedUnitPosition",
      minWidth: "150",
      showOverflowTooltip: true
    }
  ],
  operateConfig: [
    {
      icon: "icon-delete",
      name: "删除",
      permission: "topicLectureOtherTrain:delete",
    },
  ]
}